import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BreadcrumbService } from '../../services/breadcrumb/breadcrumb.service';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

interface Breadcrumb {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './app.breadcrumb.component.html',
  imports: [AsyncPipe, TranslatePipe],
})
export class AppBreadcrumbComponent {
  private readonly router = inject(Router);
  private readonly breadcrumbService = inject(BreadcrumbService);

  private readonly isInChildRoute: boolean = false;

  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  public childBreadcrumb: string = '';
  public redirectRoute = '';

  public readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      const breadcrumbs: Breadcrumb[] = [];
      if (!this.router?.currentNavigation()?.extras?.state) {
        this.redirectRoute = this.router.routerState.snapshot.url;
        this.addBreadcrumb(root, [], breadcrumbs);
        this._breadcrumbs$.next(breadcrumbs);
        this.childBreadcrumb = '';
      }
    });
    this.breadcrumbService.$breadCrumbChild.subscribe((childBreadcrumb: string) => {
      this.childBreadcrumb = ` > ${childBreadcrumb}`;
    });
  }

  public redirect() {
    this.router.navigateByUrl(this.redirectRoute, { onSameUrlNavigation: 'reload' });
    this.redirectRoute = '';
  }

  private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    const routeUrl = parentUrl.concat(route.url.map((url) => url.path));
    const breadcrumb = route.data['breadcrumb'];
    const parentBreadcrumb = route.parent?.data ? route.parent.data['breadcrumb'] : null;

    if (breadcrumb && breadcrumb !== parentBreadcrumb) {
      breadcrumbs.push({
        label: route.data['breadcrumb'],
        url: '/' + routeUrl.join('/'),
      });
    }

    if (route.firstChild) {
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }
}
